import { Icon } from "@ugitgud/legos/ui/icon/Icon";
import { UGGLogoFull } from "@ugitgud/legos/ui/icon/UGGLogoFull";
import { SvgMiscX } from "@ugitgud/legos/ui/icon/SVG/MiscX";
import { SvgLolUggPlus } from "@ugitgud/legos/ui/icon/SVG/LolUggPlus";
import { SvgUggPlusOverlay } from "@ugitgud/legos/ui/icon/SVG/UggPlusOverlay";
import classNames from "classnames";
import { useCallback, useState } from "react";
import { BannerProps } from "./WoWAppBanner";

export const DISCORD_BOT_BANNER_CTA = "discord-bot-banner";

const BANNER_ART = "https://static.bigbrain.gg/assets/ugg/cta/discord-bot-senna.png";

export function DiscordBotBanner(props: BannerProps) {
  const { url, onClick, onClose, utmSource } = props;
  const [open, setOpen] = useState(true);

  const finalUrl = utmSource ? `${url}?utm_source=${utmSource}` : url;

  const onUrlClick = (e: React.MouseEvent) => {
    e.preventDefault();
    onClick(finalUrl);
  };

  const handleClose = useCallback(() => {
    setOpen(false);
    setTimeout(() => {
      onClose?.();
    }, 150);
  }, [onClose, setOpen]);

  return (
    <div
      className={classNames(
        "transition-all relative px-[12px] w-full overflow-hidden bg-[#5A2A9F] border-b border-accent-yellow-400",
        open ? "h-[48px]" : "h-0",
      )}
    >
      <div
        className="absolute inset-0 bg-no-repeat bg-[size:1200px_auto] bg-[position:calc(100%_+_120px)_-108px] max-xs:bg-[position:calc(100%_+_600px)_-108px]"
        style={{ backgroundImage: `url(${BANNER_ART})` }}
      />
      <div className="absolute inset-0 bg-[linear-gradient(90deg,#5A2A9F_0%,#5A2A9F_calc(100%_-_800px),rgba(90,42,159,0)_calc(100%_-_280px))] max-sm:bg-[linear-gradient(90deg,#5A2A9F_0%,#5A2A9F_20%,rgba(90,42,159,0)_65%)] max-xs:bg-[linear-gradient(90deg,#5A2A9F_0%,#5A2A9F_45%,rgba(90,42,159,0)_95%)]" />
      <div
        className="absolute left-0 inset-y-0 w-[700px] max-md:w-[250px] opacity-100 max-md:opacity-50 overflow-hidden pointer-events-none max-xs:hidden"
        style={{
          WebkitMaskImage: "linear-gradient(to right, black 0%, black 10%, transparent 90%)",
          maskImage: "linear-gradient(to right, black 0%, black 10%, transparent 90%)",
        }}
      >
        <SvgUggPlusOverlay className="absolute top-1/2 -translate-y-1/2 left-[-400px] w-[1598px] h-[414px] text-accent-yellow-400" />
      </div>
      <div className="relative flex items-center justify-center gap-[32px] max-xs:gap-[12px] h-full max-md:justify-start max-xs:justify-between">
        <div className="flex items-center gap-[10px] max-sm:hidden">
          <Icon icon={<UGGLogoFull />} className="w-[60px] h-[19.55px]" />
          <Icon icon={<SvgLolUggPlus />} className="w-[46.04px] h-[21.6px]" />
        </div>
        <div className="[text-shadow:0px_1px_0px_rgba(0,_0,_0,_0.50)] translate-y-[1px]">
          <div className="flex items-center gap-[6px] font-barlow-condensed font-bold text-[18px] text-white leading-none">
            <span className="flex items-center justify-center w-[32px] h-[16px] bg-accent-blue-400 rounded-[1px] font-inter font-bold text-[10px] text-white leading-none shrink-0">
              NEW
            </span>
            STAT-TRACKING DISCORD BOT
          </div>
          <div className="font-inter font-medium text-[12px] text-white leading-[1.2] mt-[4px]">
            Follow your squad's progress in real time
          </div>
        </div>
        <a href={finalUrl} onClick={onUrlClick} className="max-sm:mr-[36px] max-xs:mr-0 shrink-0">
          <div
            className={classNames(
              "flex items-center justify-center gap-[6px] px-[12px] h-[30px] rounded-[3px] whitespace-nowrap",
              "bg-accent-blue-600 border border-accent-blue-400 drop-shadow-[0px_2px_1px_rgba(0,0,0,0.25)]",
              "font-barlow-condensed text-[13px] font-bold leading-none text-white",
              "cursor-pointer hover:bg-[#2163EC]",
            )}
          >
            <span className="font-barlow-condensed">DISCOVER</span>
            <Icon icon={<SvgLolUggPlus />} className="w-[32px] h-[15px]" />
          </div>
        </a>
      </div>
      {onClose && (
        <div
          className="absolute top-[50%] right-[12px] translate-y-[-50%] p-[6px] cursor-pointer hover:opacity-80 max-xs:hidden"
          onClick={handleClose}
        >
          <Icon icon={<SvgMiscX />} size="xs" className="text-white drop-shadow-[0px_1px_0px_rgba(0,_0,_0,_0.50)]" />
        </div>
      )}
    </div>
  );
}
